import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--services--switch"
export default class extends Controller {
  static targets = [
    "radioMains",
    "radioExtras",
    "mains",
    "extras"
  ]

  connect() {
    this.init()
  }

  init() {
    if (!this.radioMainsTarget.checked && !this.radioExtrasTarget.checked) {
      this.radioMainsTarget.checked = true
    }

    if (this.radioMainsTarget.checked) {
      this.mainsTarget.classList.remove("hidden")
      this.extrasTarget.classList.add("hidden")
    } else {
      this.mainsTarget.classList.add("hidden")
      this.extrasTarget.classList.remove("hidden")
    }
  }

  switch(event) {
    if (event.currentTarget.value === "mains") {
      this.mainsTarget.classList.remove("hidden")
      this.extrasTarget.classList.add("hidden")
    } else {
      this.mainsTarget.classList.add("hidden")
      this.extrasTarget.classList.remove("hidden")
    }
  }
}
